export const requiredValidate = (value) =>
  value || typeof value === "number" ? undefined : "Required";

export const lengthValidate =
  (minLength = 10) =>
  (value) =>
    value.length > minLength
      ? undefined
      : `Must be at least ${minLength} symbols`;

export const phoneNumberValidate = (value) => {
  const normalizedPhone = value && value.replace(/\D/g, "");
  return normalizedPhone && !/^(0|[1-9][0-9]{9})$/i.test(normalizedPhone)
    ? "Invalid phone number, must be 10 digits"
    : undefined;
};

export const emailValidate = (value) => {
  let testEmail = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  if (!testEmail.test(value)) {
    return "Please check that your email address is formatted correctly.";
  } else {
    return undefined;
  }
};
